import { proxy } from 'valtio';
import { bootstrap as bootstrapEsri } from './esri';
import { bootstrap as bootstrapGoogle } from './google';

type TStyle = { [key: string]: any } | undefined;

interface TCustomBasemaps {
  googleSatellite: TStyle;
  esriSatellite: TStyle;
}

export const customBasemaps: TCustomBasemaps = proxy({
  googleSatellite: undefined,
  esriSatellite: undefined,
});

export const CUSTOM_LAYER_IDS: string[] = [
  'googleSatellite',
  // this random ID comes from ESRI
  '10df2279f9684e4a9f6a7f08febac2a9',
  'esriHistorical',
];

export async function bootstrapCustomBasemaps() {
  customBasemaps.esriSatellite = await bootstrapEsri();
  customBasemaps.googleSatellite = await bootstrapGoogle();
}
